import React from 'react';
import { IonItem, IonItemDivider } from '@ionic/react';
import UrpassSelect from './UrpassSelect';
import { currencyFormat } from '../../utils/currency';
import { useTranslation } from 'react-i18next';
import { UrPassAgency, UrPassProduct } from '../../services/types/urpassapitypes';

type UrpassBuyProps = {
  pass: UrPassProduct;
  agency: UrPassAgency;
};
export default function UrpassBuy({ pass, agency }: UrpassBuyProps) {
  const [t] = useTranslation('global');

  return (
    <>
      <h1 className="h1 pb-4 ion-text-center">{t('urpassadd.addpasses')}</h1>
      <IonItem
        lines="none"
        className="ion-no-padding ion-pt-1 pseudo-select pseudo-select-active"
      >
        <UrpassSelect
          title={pass.name}
          subTitle={agency?.name}
          icon={agency.id}
          description={pass.description}
          midInfo={currencyFormat(pass.price)}
        />
      </IonItem>
    </>
  );
}
